import {
  Button,
  Select,
  Input,
  Row,
  Col,
  Pagination,
  Option,
  Tag,
  Tabs,
  TabPane,
  Form,
  FormItem,
  DatePicker,
  InputNumber,
  Message,
  MessageBox,
} from 'element-ui';
import BaiduMap from 'vue-baidu-map';
import VueCookie from 'vue-cookie';
import Print from 'vue-print-nb';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false;

Vue.use(BaiduMap, {ak: 'x8W0dTt2xI8fa7zq9KsdfyVp4OqB10zn'});
Vue.use(Button);
Vue.use(Select);
Vue.use(Input);
Vue.use(Row);
Vue.use(Col);
Vue.use(Pagination);
Vue.use(Option);
Vue.use(Tag);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(FormItem);
Vue.use(Form);
Vue.use(InputNumber);
Vue.use(DatePicker);
Vue.use(Print);
Vue.use(VueCookie);

Vue.prototype.$message = Message;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
